<app-header-secure></app-header-secure>
<app-toast></app-toast>
<main>
  <div id="base-container" class="container-fluid h-100 px-0">
    <div class="layout">
      <div class="sidebar" style="padding: 0 !important;" *ngIf="!sidebarService.isDashboard" 
        [class.collapsed]="sidebarService.collapsed">
        <app-main-sidebar [isCollapsed]="sidebarService.collapsed"></app-main-sidebar>
      </div>
      <div class="main-content" [class.no-padding]="sidebarService.isDashboard">        
        <router-outlet></router-outlet>
        <app-footer-basic #footer class="fixed-bottom"></app-footer-basic>
      </div>
    </div>
  </div>
</main>